module.exports = __webpack_public_path__ + "img/merch-2.3e0b948c.png";